import {
    buildComponentSlice,
    useComponentSlice,
    WidgetComponentSliceActionPayloadType,
} from 'widgets/store/component/componentSlice';

import { WidgetType } from 'widgets/WidgetType';
import { selectVolumeCurveState } from '../selectors';
import {
    initialVolumeCurveComponentState,
    VolumeCurveComponentState,
} from 'widgets/volumeCurve/store/component/VolumeCurveComponentState.ts';

export const buildVolumeCurveComponentSlice = () =>
    buildComponentSlice<VolumeCurveComponentState>(
        WidgetType.VOLUME_CURVE,
        selectVolumeCurveState,
        initialVolumeCurveComponentState
    );

export const useVolumeCurveComponentSlice = () =>
    useComponentSlice(buildVolumeCurveComponentSlice());

export type VolumeCurveComponentPayloadType =
    WidgetComponentSliceActionPayloadType<VolumeCurveComponentState>;
